import React from 'react';
import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../../utils/ProtectedRoute';
import BookingListView from './bookingsListView/BookingListView';
import YourBookingDetail from './YourBookingDetail';
import { ProviderYourBookings } from '../../contextsProperty/ContextBookings';
import {
    AppSections,
    AppSectionsCore,
} from '../../../types/appConfiguration/appConfigTypes';

const Bookings = ({ match }) => {
    return (
        <ProviderYourBookings>
            <Switch>
                <ProtectedRoute
                    path={`${match.path}/:encodedIdBooking`}
                    render={props => <YourBookingDetail {...props} />}
                    section={AppSections.CORE}
                    page={AppSectionsCore.BOOKINGS}
                />
                <ProtectedRoute
                    path={`${match.path}`}
                    render={props => <BookingListView {...props} />}
                    section={AppSections.CORE}
                    page={AppSectionsCore.BOOKINGS}
                />
            </Switch>
        </ProviderYourBookings>
    );
};

export default Bookings;
